import { useUserStore } from '@/stores'

export function hasPermission(permission) {
    const userStore = useUserStore()

    if (!permission) return true

    // Check if permissions is an array
    if (!Array.isArray(userStore.permissions)) return false

    // If permission is an array, check if user has any of them (OR logic)
    if (Array.isArray(permission)) {
        return permission.some((perm) => userStore.permissions.some((userPerm) => userPerm.name === perm))
    }

    // Single permission check
    return userStore.permissions.some((perm) => perm.name === permission)
}

// Composable that returns the same function
export function usePermissionHandler() {
    return { hasPermission }
}
